import {HttpStatus} from './Constants';

export const DEFAULT_LOGIN_FAILURE_ACTION_TYPE = 'LOGIN_FAILURE';
export const DEFAULT_NO_401_REDIRECT_ATTRIBUTE = 'no401redirect';

const createRedirect401Middleware = (loginFailureActionType = DEFAULT_LOGIN_FAILURE_ACTION_TYPE, no401redirectAttribute = DEFAULT_NO_401_REDIRECT_ATTRIBUTE) => {
    return store => next => action => {
        if (action.error && action.error.response && action.error.response.status === HttpStatus.UNAUTHORIZED && !action[no401redirectAttribute]) {
            next(action);
            return store.dispatch({type: loginFailureActionType});
        }

        return next(action);
    }
};

export default createRedirect401Middleware;



// WEBPACK FOOTER //
// ./src/redirect401Middleware.js